<template>
    <div>
        <section>
            <div v-if="inSection">
                <div class="spacer"></div>
                <h3 class="h4">Noticias</h3>
            </div>
            <div class="row">
                <template v-if="loaded">
                    <div class="col-6 col-lg-4 p-1 p-sm-2 p-md-3" v-for="(repeat, index) in 6" :key="index">
                        <div class="text-dark text-decoration-none bg-light card h-100">
                            <div class="card-img-notice rounded" style="background-color: #ddd"></div>
                            <div class="card-body  p-3 p-md-4">
                                <h5>{{repeat.a}}&nbsp;</h5>
                                <p class="small"></p>
                                <button type="button" class="btn btn-white mt-2">&nbsp;</button>
                            </div>
                        </div>
                    </div>
                </template>
                <div v-else class="col-6 col-lg-4 p-1 p-sm-2 p-md-3" v-for="(notice, index) in filteredNotices" :key="index">
                    <RouterLink :to="{name:'Notice', params:{id: notice.noticeId}}" class="text-dark text-decoration-none bg-light card h-100">
                        <div class="card-img-notice rounded" :style="{'background-image':`url(${notice.thumbnail})`}"></div>
                        <div class="card-body p-3 p-md-4">
                            <h5 class="text-capitalize">{{notice.title | maxLength(60)}}</h5>
                            <p class="small">{{notice.createdAt | moment("from") }}</p>
                            <div class="mt-n3 mb-1">
                                <div class="badge badge-pill badge-info mr-1" v-for="category in notice.categories" :key="category">{{category}}</div>
                            </div>
                            <button type="button" class="btn mt-2" :class="`btn-${(index%2)?'danger':'primary'}`">Ver más</button>
                        </div>
                    </RouterLink>
                </div>
                <div class="col-12 p-3" v-show="!filteredNotices.length"><h5>No se han encontrado noticias</h5></div>

            </div>

            <div class="pt-2 text-center" v-if="inSection">
                <RouterLink :to="{name: 'Notices'}" type="button" class="btn btn-lg btn-success mt-2">Ver noticias</RouterLink>
            </div>

        </section>
    </div>
</template>

<script>
export default {
    props:{
        inSection:{
            type: Boolean
        },
        limit:{
            type: Number,
            default: Infinity
        }
    },
    data(){
        return{
            loaded: true
        }
    },
    async created(){
        await this.$store.dispatch('notice/getNotices', this.limit)
        this.loaded = false
    },
    destroyed(){
        
    },
    computed:{
        notices(){
            return this.$store.state.notice.notices
        },
        filters(){
            return this.$store.state.notice.filters 
        },
        filteredNotices(){
            return this.notices.filter(notice => {
                
                var queryCategories = false
                if(this.filters.categories.length){
                    notice.categories.forEach(category => {
                        if(this.filters.categories.includes(category)){
                            queryCategories = true
                        }
                    })
                }
                
                if(queryCategories){
                    return notice
                }else if(!this.filters.categories.length){
                    return notice
                }
                
            })
        }
    },
    filters:{
        maxLength(data, length){
            if(data.length > length){
                return `${data.substring(0, length)}...`
            }else{
                return data
            }
        }
    }
}
</script>